
import angular from 'angular';

import configurableChart from './configurable-chart';

export default angular.module('directive.configurable-chart', [])
	.controller('configurableChartController', function() {})
	.directive('configurableChart', configurableChart)
	.name;



// WEBPACK FOOTER //
// ./src/directive/configurable-chart/index.js